export function Tooth({ size = 24, className = "", strokeWidth = 2, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path d="M12 5.5c-1.5-1.5-3.5-2.2-5.2-1.6C4.8 4.6 3.7 6.5 3.7 8.8c0 1.6.4 2.9.8 4.6.3 1.2.5 2.6.7 4 .2 1.5.4 2.9 1.4 3.4.9.5 1.7-.2 2.1-1.3.4-1.1.6-2.6.9-3.8.2-.9.8-1.6 1.7-1.6s1.5.7 1.7 1.6c.3 1.2.5 2.7.9 3.8.4 1.1 1.2 1.8 2.1 1.3 1-.5 1.2-1.9 1.4-3.4.2-1.4.4-2.8.7-4 .4-1.7.8-3 .8-4.6 0-2.3-1.1-4.2-3.1-4.9-1.7-.6-3.7.1-5.2 1.6Z" />
    </svg>
  );
}
